import React from 'react';

interface LobbyStatusLoaderProps {
  isFetching: boolean;
  totalRowCount: number;
}

const LobbyStatusLoader: React.FC<LobbyStatusLoaderProps> = ({ isFetching, totalRowCount }) => {
  return (
    <>
      {isFetching && <div className="flex h-full items-center justify-center py-2">Loading...</div>}
      {!isFetching && totalRowCount === 0 && (
        <div className="flex h-full items-center justify-center py-2">
          <span className="text-white text-opacity-50">No friends yet</span>
        </div>
      )}
    </>
  );
};

export default LobbyStatusLoader;
